module.exports = __webpack_public_path__ + "static/img/PattyMills.a79ba01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PattyMills.jpg
// module id = aofJ
// module chunks = 0